import { X } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Button } from "@/components/ui/button";

export default function TransactionHistoryModal({ 
  customer, 
  transactions, 
  onClose 
}) {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-lg">📋 Historique des transactions</h3>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="p-4">
          <div className="mb-4 p-3 bg-slate-50 rounded-lg">
            <p className="font-medium">{customer.first_name} {customer.last_name}</p>
            <p className="text-sm text-slate-500">2 derniers mois</p>
          </div>
          
          {transactions.length === 0 ? (
            <p className="text-center text-slate-500 py-8">Aucune transaction</p>
          ) : (
            <div className="space-y-2 max-h-80 overflow-y-auto">
              {transactions.map((t) => (
                <div 
                  key={t.id} 
                  className={`flex items-center justify-between p-3 rounded-lg ${
                    t.type === "sakura_draw"
                      ? (t.prize && t.prize !== "nothing" ? "bg-pink-100" : "bg-slate-50")
                      : t.type === "referral_bonus"
                        ? "bg-purple-50"
                        : t.type === "loyalty" 
                          ? (t.rewards_earned > 0 ? "bg-yellow-50" : "bg-pink-50")
                          : (t.action === "add" ? "bg-green-50" : "bg-orange-50")
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <span className="text-lg">
                      {t.type === "sakura_draw" 
                        ? "🌸" 
                        : t.type === "referral_bonus"
                          ? "🤝"
                          : t.type === "shirts" 
                            ? "👔" 
                            : t.type === "loyalty" 
                              ? (t.rewards_earned > 0 ? "🎁" : "🧾") 
                              : "💰"}
                    </span>
                    <div>
                      <p className={`font-medium ${
                        t.type === "sakura_draw"
                          ? (t.prize && t.prize !== "nothing" ? "text-pink-700" : "text-slate-600")
                          : t.type === "referral_bonus"
                            ? "text-purple-700"
                            : t.type === "loyalty" 
                              ? (t.rewards_earned > 0 ? "text-yellow-700" : "text-pink-700")
                              : (t.action === "add" ? "text-green-700" : "text-orange-700")
                      }`}>
                        {t.description}
                      </p>
                      {t.type === "referral_bonus" && (
                        <p className="text-xs text-purple-600">
                          +{t.amount}€ crédités sur le prépaiement
                        </p>
                      )}
                      {t.type === "loyalty" && t.excluded_from_loyalty > 0 && (
                        <p className="text-xs text-amber-600">
                          👗👔 {t.excluded_from_loyalty}€ hors fidélité
                        </p>
                      )}
                      {t.type === "loyalty" && t.discount_applied > 0 && (
                        <p className="text-xs text-green-600 font-medium">
                          💰 Remise: -{t.discount_applied}€ → Payé: {((t.loyalty_amount || t.amount || 0) - (t.discount_applied || 0)).toFixed(2)}€
                        </p>
                      )}
                      {t.type !== "sakura_draw" && t.type !== "referral_bonus" && (
                        <p className="text-xs text-slate-500">
                          {t.type === "shirts" 
                            ? `Solde: ${t.balance_after} chemise(s)` 
                            : t.type === "loyalty"
                              ? `Progression: ${t.balance_after?.toFixed(2)}€ / 50€`
                              : `Solde: ${t.balance_after?.toFixed(2)}€`
                          }
                        </p>
                      )}
                    </div>
                  </div>
                  <span className="text-xs text-slate-500">
                    {format(new Date(t.created_at), "dd/MM/yy HH:mm", { locale: fr })}
                  </span>
                </div>
              ))}
            </div>
          )}
          
          <div className="flex justify-end mt-4">
            <Button variant="outline" onClick={onClose}>
              Fermer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
